"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var createConsumerApi_1 = tslib_1.__importDefault(require("./createConsumerApi"));
exports.createConsumerApi = createConsumerApi_1["default"];
var readFromConsumerApi_1 = tslib_1.__importDefault(require("./readFromConsumerApi"));
exports.readFromConsumerApi = readFromConsumerApi_1["default"];
var index_1 = require("./registry/index");
exports.SynchronousRegistry = index_1.SynchronousRegistry;
exports.SynchronousMetaRegistry = index_1.SynchronousMetaRegistry;
exports["default"] = readFromConsumerApi_1["default"]('manifest');
//# sourceMappingURL=index.js.map